import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Tabs,
  Tab,
} from '@mui/material';
import {
  People as PeopleIcon,
  SystemUpdate as SystemUpdateIcon,
} from '@mui/icons-material';

import AdminManagementTab from './AdminManagementTab';
import AppVersionTab from './AppVersionTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

const SettingsPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          設定
        </Typography>
        <Typography variant="body1" color="text.secondary">
          システム設定と管理者アカウントの管理を行います。
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="設定タブ">
            <Tab 
              icon={<PeopleIcon />} 
              iconPosition="start" 
              label="管理者管理" 
              {...a11yProps(0)} 
            />
            <Tab 
              icon={<SystemUpdateIcon />} 
              iconPosition="start" 
              label="アプリバージョン管理" 
              {...a11yProps(1)} 
            />
          </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0}>
          <AdminManagementTab />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AppVersionTab />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default SettingsPage; 